import httpWrapper from '../HttpWrapper'
import { AdminGetRes } from './models/adminGet/AdminGetRes'
import { CreateTenantReq } from './models/createTenant/CreateTenantReq'
import { CreateTenantRes } from './models/createTenant/CreateTenantRes'
import { GetAllRes } from './models/getAll/GetAllRes'
import { GetLoggedInUserRes } from './models/getLoggedInUser/GetLoggedInUserRes'
import { CreateUserReq } from './models/createUser/CreateUserReq'
import { CreateUserRes } from './models/createUser/CreateUserRes'
import { UpdateUserReq } from './models/updateUser/UpdateUserReq'
import { UserDto } from './models/UserDto'
import { UpdateUserSettingsReq } from './models/updateUserSettings/UpdateUserSettingsReq'
import { GetAvailableSeeds } from './models/getAvailableSeeds/GetAvailableSeedsRes'

class TenantApi {
    private static instance: TenantApi

    public constructor() {
        if (TenantApi.instance) {
            return TenantApi.instance
        }

        TenantApi.instance = this
    }

    public async getAll(): Promise<GetAllRes> {
        return await httpWrapper.get('/tenant/all')
    }

    public async getLoggedInUser(): Promise<GetLoggedInUserRes> {
        return await httpWrapper.get(`/tenant/get-logged-in-user`)
    }

    public async createTenant(
        createTenantReq: CreateTenantReq,
    ): Promise<CreateTenantRes> {
        return await httpWrapper.post('/tenant/create', createTenantReq)
    }

    public async adminGet(tenantId: string): Promise<AdminGetRes> {
        const queryParams = new URLSearchParams({
            tenantId,
        })

        return await httpWrapper.get('/tenant/admin-get', queryParams)
    }

    public async getUser(userId: string): Promise<{ user: UserDto }> {
        const queryParams = new URLSearchParams({
            userId,
        })

        return await httpWrapper.get('/tenant/get-user', queryParams)
    }

    public async createUser(
        createUserReq: CreateUserReq,
    ): Promise<CreateUserRes> {
        return await httpWrapper.post('/tenant/create-user', createUserReq)
    }

    public async updateUser(updateUserReq: UpdateUserReq): Promise<void> {
        await httpWrapper.post('/tenant/update-user', updateUserReq)
    }

    public async updateUserSettings(
        updateUserSettingsReq: UpdateUserSettingsReq,
    ): Promise<void> {
        await httpWrapper.post(
            '/tenant/update-user-settings',
            updateUserSettingsReq,
        )
    }

    public async addNetworkSeedPerson(
        personId: string,
        tenantId: string,
    ): Promise<void> {
        await httpWrapper.post('/tenant/add-network-seed-person', {
            personId,
            tenantId,
        })
    }

    public async removeNetworkSeedPerson(
        personId: string,
        tenantId: string,
    ): Promise<void> {
        await httpWrapper.post('/tenant/remove-network-seed-person', {
            personId,
            tenantId,
        })
    }

    public async linkTenantToCompanies(
        companyIds: string[],
        tenantId: string,
    ): Promise<void> {
        await httpWrapper.post('/tenant/link-tenant-to-companies', {
            companyIds,
            tenantId,
        })
    }

    public async getAvailableSeeds(): Promise<GetAvailableSeeds> {
        return await httpWrapper.get('/tenant/get-available-seed-ids')
    }

    public async unlinkCompanyFromTenant(
        companyId: string,
        tenantId: string,
    ): Promise<void> {
        await httpWrapper.post('/tenant/unlink-company-from-tenant', {
            companyId,
            tenantId,
        })
    }
}

const tenantApi = new TenantApi()
export default tenantApi
